const OB= {"storedEdits":{"all":""},"mqOrder":["all","@media screen and (max-width:1024px)","@media screen and (max-width:768px)","@media screen and (max-width:667px)","@media screen and (max-width:375px)"],"animatedEls":{},"storedJS":{"all":"","libs":[],"stripped":""},"videoBgs":{},"customFonts":{},"session":1661101392384}


if (typeof window.placeVidElementInner === 'undefined'){
    window.placeVidElementInner = function(selector,options,frame,showOnlyPoster){
        const {pos,url,customizations,thumbnail} = options;
        const {outer,inner} = customizations;
        const outerCustomStyle = [];
        const innerCustomStyle = [];
        let outS = {};
        let inS = {}
        for (let o in outer){
            outerCustomStyle.push(o+':'+outer[o])
            let niceO = o;
            if (o === 'background-color') niceO = 'backgroundColor'
            
            outS[niceO] = outer[o]
        }
        
        for (let o in inner){
            innerCustomStyle.push(o+':'+inner[o])
            let niceO = o;
            if (o === 'mix-blend-mode') niceO = 'mixBlendMode'
            inS[niceO] = inner[o]
        }
        const destination = frame ? frame.document : document;
        const els = destination.querySelectorAll(selector);
        const defSty = 'position:absolute;top:0;left:0;z-index:-1;height:100%;width:100%;pointer-events:none;'
        
        els.forEach(e=>{
            const outerEl = document.createElement('div')
            outerEl.setAttribute('style',defSty+outerCustomStyle.join(';'))
            outerEl.className = 'heroVideoBg'
            const vidEl = document.createElement('video');
            vidEl.src = !showOnlyPoster ? url : '';
            vidEl.autoplay = true;
            vidEl.poster = thumbnail;
            vidEl.loop = true
            vidEl.muted = true
            vidEl.playsInline = true
            vidEl.preload = 'none'
            vidEl.setAttribute('style',defSty+'object-fit:cover;object-position:'+pos+';'+innerCustomStyle.join(';'))
            outerEl.appendChild(vidEl)
            e.appendChild(outerEl)
        })
        
        return {inS,outS,thumbnail,url}
    }
}

document.addEventListener("DOMContentLoaded", ()=>{


    try{

        
        if (OB && window.location.href.indexOf('?shop')===-1){
            
            
            const {videoBgs,storedJS} = OB;
            
            for (let v in videoBgs){
                const {url,pos,customizations,thumbnail,disableOnMobile} = videoBgs[v];
                const posterOnly = disableOnMobile && window.matchMedia('(max-width: 1024px)').matches
                    
                window.placeVidElementInner(v,{url,pos,customizations,thumbnail},false,posterOnly)
            }

            const {libs,stripped} = storedJS;
            if (libs && libs.length > 0){
                libs.forEach(l=>{
                    const scr = document.createElement('script');
                    scr.setAttribute('src',l);
                    scr.classList.add('csshero-js-lib')
                    document.head.appendChild(scr);
                })
            }
            if (stripped){
                const scr = document.createElement('script');
                scr.setAttribute('id','csshero-js-code')
                scr.innerHTML = stripped
                document.head.appendChild(scr)
            }
        }
    } catch(err){
        // ERROR, NO OB?
    }
})